/* global translations, globals */
import React from 'react';
// import ReactDOM from 'react-dom';
import _ from 'lodash';
import $ from 'jquery';
import PropTypes from 'prop-types';
// import { ImageSvg } from '../image';
import PermissionsStore from '../../stores/PermissionsStore';

const availableBrowserInstructions = {
  geolocation: ['firefox', 'chrome'],
};

class PermissionsInstructionsBox extends React.Component {
  componentDidMount() {
    $('.overlay-main').removeClass('hide');
  }

  componentWillUnmount() {
    $('.overlay-main').addClass('hide');
  }

  handleClose = () => {
    PermissionsStore.hideInstructions(this.props.type);
    $('.overlay-main').addClass('hide');
  };

  hasCustomInstructions = (type, browser) => {
    if (availableBrowserInstructions[type] !== 'undefined'
      && (availableBrowserInstructions[type].indexOf(browser) !== -1)
    ) {
      return true;
    }

    return false;
  };

  render() {
    //
    const { type, browser } = this.props;

    //
    const content = () => {
      if (this.hasCustomInstructions(type, browser)) {
        return (
          <img
            alt=""
            src={`${_.get(globals, 'staticImageUri', '/img/')}permissions/${browser}/${type}.png`}
          />
        );
      }

      return (
        <div className="permissionsInstructionsBox-customContent permissionsInstructionsBox-customContent--geolocation">
          {translations['txt: Atrašanās vietas dati ir izslēgti. Lūdzu veic izmaiņas sava pārlūka uzstādījumos, lai tos ieslēgtu.']}
          <br />
        </div>
      );
    };

    return (
      <div className="permissionsInstructionsBox">
        {this.hasCustomInstructions(type, browser) && (
          <div className="permissionsInstructionsBox-title">
            {translations['txt: Atbloķē piekļuvi savai atrašanās vietai!']}
          </div>
        )}
        <div>
          {content()}
        </div>
        <br />
        <div role="presentation" className="btn btn--a" onClick={this.handleClose}>
          {translations['txt: Sapratu']}
        </div>
      </div>
    );
  }
}

PermissionsInstructionsBox.propTypes = {
  browser: PropTypes.string,
  type: PropTypes.string,
};

PermissionsInstructionsBox.defaultProps = {
  browser: '',
  type: '',
};

export default PermissionsInstructionsBox;
